import DataGrid, {Column, Format, Summary, TotalItem} from 'devextreme-react/data-grid';
import {formatNumber} from 'devextreme/localization';
import {useContext} from 'react';
import {QuoteTypes} from '../../../../types/enums';
import {EstimateContext} from '../context/EstimateContext';

export default function EstimateItemsGrid() {

    const {order} = useContext(EstimateContext);
    const isLead = order.details.quoteTypeID === QuoteTypes.Lead;

    return (
        <div className='dx-card wide-card'>
            <div className='grid-header'>{isLead ? 'Lead' : 'Estimate'} Details</div>
            <DataGrid
                dataSource={order.details.items}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                showColumnLines={true}
                columnAutoWidth={true}
                keyExpr={'quoteItemsID'}
                className="grid-with-header"
            >
                <Column
                    dataField={'sku'}
                    caption={'SKU'}
                    dataType="string"
                />
                <Column
                    dataField={'productLine'}
                    caption={'Product Line'}
                    dataType="string"
                />
                <Column
                    dataField={'description'}
                    caption={'Item Description'}
                    dataType="string"
                />
                <Column
                    dataField={'quantity'}
                    caption={'Qty'}
                    dataType="number"
                />
                <Column
                    dataField={'uom'}
                    caption={'UOM'}
                    dataType="string"
                />
                <Column
                    dataField={'dealerCost'}
                    caption={'Unit Costs'}
                    visible={order.details?.showDealerCost}
                    dataType="number"
                >
                    <Format type="currency" precision={2}></Format>
                </Column>
                <Column
                    dataField={'extDealerCost'}
                    caption={'Extended Costs'}
                    visible={order.details?.showDealerCost}
                    dataType="number"
                >
                    <Format type="currency" precision={2}></Format>
                </Column>
                <Column
                    dataField={'retailPrice'}
                    caption={'Retail Price'}
                    dataType="number"
                >
                    <Format type="currency" precision={2}></Format>
                </Column>
                <Column
                    dataField={'extRetailPrice'}
                    caption={'Ext. Retail Price'}
                    dataType="number"
                >
                    <Format type="currency" precision={2}></Format>
                </Column>
                <Summary>
                    <TotalItem
                        column="extDealerCost"
                        summaryType="sum"
                        customizeText={(data: any) => 'Total: ' + formatNumber(data.value, {
                            type: 'currency',
                            precision: 2
                        })}
                    />
                    <TotalItem
                        column="extRetailPrice"
                        summaryType="sum"
                        customizeText={(data: any) => 'Total: ' + formatNumber(data.value, {
                            type: 'currency',
                            precision: 2
                        })}
                    />
                </Summary>
            </DataGrid>
        </div>
    );
}
